<template>
	<section id="minha_conta">
		<div class="container">
			<div class="area_title">MINHA CONTA</div>
			<div class="dados">
				<div class="foto"><img alt="Foto do perfil" src="http://portaldoaluno.webaula.com.br//FotosPersonagem/fotoDefaultAluno.jpg"></div>
				<div class="descricao">
					<div>{{ $auth.user().nome }}</div>
					<div>{{ $auth.user().email }}</div>
					<div>Perfil: {{$auth.user().nomePerfil }}</div>
				</div>
			</div>
			<div class="collections">
				<div class="container1">
					<div class="area_title">Últimas coleções criadas</div>
					<div class="collections_list">
						<CollectionItem v-for="lc in last_collections5" :key="lc.id" :name="lc.nome" :lastUpdate="new Date()" />
					</div>
					<div class="collections_actions">
						<button>Visualizar todas as coleções</button>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import axios from 'axios'
import CollectionItem from '@/components/shared/CollectionItem'
export default {
	name: 'MinhaConta',
	data () {
		return {
			lastCollections: []
		}
	},
	computed: {
		last_collections5 () {
			return (this.lastCollections) ? this.lastCollections.slice(0, 5) : false
		}
	},
	components: {
		CollectionItem
	},
	async created () {
		this.getCollections()
	},
	methods: {
		getCollections () {
			const lastCollections = axios.get('/colecoes')

			Promise.all([lastCollections]).then(data => {
				this.lastCollections = data[0].data
			})
		}
	}
}
</script>

<style lang="scss" scoped>
	#minha_conta {
		margin-top: 120px;
		@media all and (max-width: 700px) {
			& {
				margin-top: 0 !important;
			}
		}

		background-size: 30px;
		background-image: url('../../../assets/images/bg.svg'), linear-gradient(180deg, transparent, rgba(255,255,255,0), rgba(27, 40, 56, 1));
		color: #fff;

		.container {
			.dados {
				border: 2px solid #21344D;
				background-color: #061529;
				border-radius: 10px;
				display: flex;
				.foto {
					padding: 20px;
					img {
						border-radius: 100%;
						width: 180px;
						height: 180px;
						border: 5px solid #21344D;
					}
				}
				.descricao {
					display: flex;
					flex-direction: column;
					justify-content: center;
					div:first-child {
						font-size: 21px;
					}
					div:nth-child(2n) {
						font: Condensed 16px/26px Roboto;
						color: #E2E41A;
					}
					div:last-child {
						font: Condensed Light Italic 14px/26px Roboto;
						color: #FFFFFF;
					}
				}
			}

			.collections {
				.collections_actions {
					text-align: center;

					button {
						padding: 15px 25px;
						border: none;
						border-radius: 5px;
						background-color: #00659D;
						color: #FFF;
						text-transform: uppercase;
						font-size: 16px;
						letter-spacing: .5px;
						font-family: 'Roboto Condensed', 'Roboto', sans-serif;
						font-weight: bold;
						margin-top: 30px;
						cursor: pointer;
					}
				}
			}

			.likes {
				.card_list {
					display: flex;
					flex-wrap: nowrap;
					justify-content: space-between;
					margin-bottom: 10px;

					@media all and (max-width: 1366px) {
						display: grid;
						grid-template-columns: repeat(3, 1fr);
						grid-gap: 10px 10px;

						@media all and (max-width: 700px) {
							& {
								grid-template-columns: repeat(2, 1fr);
							}

							@media all and (max-width: 500px) {
								& {
									grid-template-columns: 1fr;
								}
							}
						}
					}
				}

				.likes_actions {
					text-align: center;

					button {
						width: 300px;
						padding: 15px 25px;
						border: none;
						border-radius: 5px;
						background-color: #00659D;
						color: #FFF;
						text-transform: uppercase;
						font-size: 16px;
						letter-spacing: .5px;
						font-family: 'Roboto Condensed', 'Roboto', sans-serif;
						font-weight: bold;
						margin-top: 30px;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>
